<template>
  <div class="view-wrapper view-wrapper-with-header">
    <van-nav-bar
      title="新影联票卡"
      left-arrow
      @click-left="$router.go(-1)"
      @click-right="add()"
      class="fixed-top"
    >
      <template #right>
        <van-icon name="add-o" size="16" style="margin-right:2px;" />绑定
      </template>
    </van-nav-bar>
    <div>
      <van-tabs v-model="active" swipeable class="sticky-tabs">
        <van-tab title="可用" name="1">
          <van-pull-refresh
            v-model="groups.s1.pullLoading"
            @refresh="onPullRefresh(1)"
            class="pull-content"
          >
            <van-list
              v-model="groups.s1.loading"
              :finished="groups.s1.finished"
              finished-text="没有更多了"
              @load="onLoad(1)"
              class="order-list"
            >
              <CouponItem
                v-for="item in groups.s1.list"
                :key="item.ticketNo"
                :coupon="item"
                @on-remove="onRemoveTicket"
              ></CouponItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="不可用" name="2">
          <van-pull-refresh
            v-model="groups.s2.pullLoading"
            @refresh="onPullRefresh(2)"
            class="pull-content"
          >
            <van-list
              v-model="groups.s2.loading"
              :finished="groups.s2.finished"
              finished-text="没有更多了"
              @load="onLoad(2)"
              class="order-list"
            >
              <CouponItem
                v-for="item in groups.s2.list"
                :key="item.ticketNo"
                :coupon="item"
                @on-remove="onRemoveTicket"
              ></CouponItem>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <van-popup
      v-model="addForm.show"
      round
      position="bottom"
      style="height:70%;"
      class="popup-box"
    >
      <div class="title van-hairline--bottom">绑定新影联票卡</div>
      <div>
        <van-form @submit="onSubmitAdd">
          <van-field
            v-model="addForm.data.ticketNo"
            clearable
            name="ticketNo"
            label="卡号"
            placeholder="卡号"
            :rules="[{ required: true, message: '请填写卡号' }]"
          />
          <van-field
            v-model="addForm.data.ticketPwd"
            clearable
            type="password"
            name="ticketPwd"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <van-field
            v-model="addForm.data.imgCode"
            clearable
            type="digit"
            name="imgCode"
            label="验证码"
            placeholder="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          >
            <template #extra>
              <div style="width:130px;height:30px;text-align:right;">
                <img
                  :src="imgBase64"
                  alt="图片验证码"
                  @click="getImgCode"
                  style="height:30px;"
                />
              </div>
            </template>
          </van-field>
          <div style="margin: 16px;">
            <van-button round block type="danger" native-type="submit"
              >绑定</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import CouponItem from "@/components/CouponItem.vue";
export default {
  name: "Coupons",
  components: {
    CouponItem,
  },
  data() {
    return {
      active: "1",
      list: [],
      uuid: "",
      imgBase64: "",
      loading: false,
      finished: false,
      groups: {
        s1: {
          page: 1,
          size: 15,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false,
        },
        s2: {
          page: 1,
          size: 15,
          loading: false,
          finished: false,
          list: [],
          first: true,
          pullLoading: false,
        },
      },
      addForm: {
        show: false,
        data: {
          ticketNo: "",
          ticketPwd: "",
          imgCode: "",
          uuid: "",
        },
      },
    };
  },
  created() {
    //this.loadData(1);
  },
  activated() {
    this.getImgCode();
  },
  methods: {
    reloadData(){
      let gpData = this.groups["s" + this.active];
      gpData.page = 1;
      gpData.finished = false;
      //this.loadData(this.active);

    },
    loadData(status) {
      //let status = this.active;
      let gpData = this.groups["s" + status];
      //console.log(statusOrders);
      this.$ajax
        .get("/api/user/coupons", {
          params: {
            page: gpData.page,
            size: gpData.size,
            type: status,
          },
        })
        .then((response) => {
          //success
          gpData.loading = false;
          gpData.pullLoading = false;
          if (response.data.code === 1) {
            //console.log(response.data.data);
            let data = response.data.data;
            //没有了
            if (data != null) {
              if (data.length === 0) {
                gpData.finished = true;
              }
              if (gpData.page === 1) {
                gpData.list = response.data.data;
              } else {
                gpData.list = gpData.list.concat(data);
              }
            } else {
              gpData.finished = true;
            }
            gpData.page++;
            //statusOrders.finished = true;
          }
        });
    },
    onPullRefresh(status) {
      let gpData = this.groups["s" + status];
      gpData.page = 1;
      gpData.finished = false;
      this.loadData(status);
      //console.log("下拉");
    },
    onLoad(status) {
      let gpData = this.groups["s" + status];
      if (!gpData.pullLoading) {
        this.loadData(status);
      }
    },
    //票卡绑定
    add() {
      this.addForm.show = true;
    },
    //验证码
    getImgCode() {
      this.$ajax
        .get("/api/account/validcode?t=" + this.uuid)
        .then((response) => {
          if (response.data.code === 1) {
            //console.log(response);
            this.imgBase64 = response.data.data.img;
            this.uuid = response.data.data.uuid;
          }
        });
    },
    onSubmitAdd(values) {
      console.log(values);
      this.addForm.data.uuid = this.uuid;
      this.$ajax
        .post("/api/user/bind-coupon", this.addForm.data)
        .then((response) => {
          if (response.data.code === 1) {
            //success
            this.$toast.success("添加成功");
            this.reloadData();
            this.addForm.show=false;
          } else {
            this.$toast.fail(response.data.message);
          }
          this.getImgCode();
        });
    },
    //解绑票卡
    onRemoveTicket(item) {
      //console.log(item);
      this.$dialog
        .confirm({
          title: "解绑确认",
          message: "确认要解绑票卡：" + item.ticketNo + " 吗？",
        })
        .then(() => {
          // on confirm
          this.$ajax
            .post("/api/user/remove-coupon", {
              ticketNo: item.ticketNo,
            })
            .then((response) => {
              if (response.data.code === 1) {
                //success
                this.$toast.success("解绑成功");
                //删除列表
                let gpData = this.groups["s" + this.active];
                var idx=gpData.list.indexOf(gpData.list.find(o=>o.ticketNo===item.ticketNo));
                gpData.list.splice(idx,1);

              } else {
                this.$toast.fail(response.data.message);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="less" scoped>
.pane-con {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
.popup-box {
  .title {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
